import { SwitchProps } from "@/types/component";

import "./index.scss";

import React, { useState } from "react";

/**
 * Fully controlled Switch.
 *
 * Önceki sürüm `checked` prop'unu yalnızca ilk render'da `useState`'e alıyor,
 * sonrasında internal state ile çalışıyordu — uncontrolled davranış. Bu yüzden
 * aynı modal içinde `checked` değiştirilince (örn. ardışık iki farklı kaydı
 * edit etmek için modalı tekrar açınca) toggle parent prop'uyla senkron
 * kalmıyor, görsel olarak yanlış konumda takılı görünüyordu. Artık `checked`
 * tek doğru kaynak; hover sadece görsel için internal.
 */
const Switch: React.FC<SwitchProps> = ({
  checked = false,
  disabled = false,
  onChange,
  variant = "default",
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };

  return (
    <div
      className={`switch ${variant} ${checked ? "checked" : "unchecked"} ${
        disabled ? "disabled" : ""
      } ${isHovered ? "hover" : ""}`}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || undefined}
    >
      <div className="switch-toggle"></div>
    </div>
  );
};

export default Switch;
